import { render } from "./StoreWithRateList.vue?vue&type=template&id=66fd1b17&scoped=true&ts=true"
import script from "./StoreWithRateList.vue?vue&type=script&lang=ts"
export * from "./StoreWithRateList.vue?vue&type=script&lang=ts"

import "./StoreWithRateList.vue?vue&type=style&index=0&id=66fd1b17&scoped=true&lang=scss"

import exportComponent from "/builds/web-primary/web-novel-stores/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66fd1b17"]])

export default __exports__